import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { githubAuthApiRef } from '@backstage/core-plugin-api';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

const githubSignInPageExtension = SignInPageBlueprint.make({
  params: {
    loader: async () => props => (
      <SignInPage
        {...props}
        providers={[
          {
            id: 'github-auth-provider',
            title: 'GitHub',
            message: 'Sign in with GitHub',
            apiRef: githubAuthApiRef,
          },
        ]}
      />
    ),
  },
});

export const githubSignInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [githubSignInPageExtension],
});
